export default ['region-orders', 'dashboard-manufactures', 'global-settings']